/** 按需引入echarts */
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import { TooltipComponent, GridComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([TooltipComponent, GridComponent, BarChart, CanvasRenderer]);
export default echarts;
